// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  display: flex;
  margin-right: 13px;
  margin-left: 13px;
  width: calc(100% - 26px);
  border-bottom: 1px solid ${(props) => props.theme.colorPalette.gray[600]};
  .zip-code-field {
    flex: 1;
    .TextBox__label {
      top: 10px;
    }
    .TextBox__input {
      height: 42px;
      box-sizing: border-box;
    }
    .input-fields-wrapper {
      margin-right: 16px;
    }
  }
  .zip-code-cta {
    max-width: 106px;
    flex: 1;
    padding: 10px 20px;
    border-radius: 6px;
  }
  .TextBox__label.nonActive {
    top: -8px;
    font-size: ${(props) => props.theme.typography.fontSizes.fs12};
  }
`;

export default styles;
